import { Principal } from 'types/connectTypes';
import { CONNECT_JOBBOARD_STATES } from 'utils/constants/connect';
import { connectRedirectUrls } from 'utils/constants/urls';
import { USStates } from 'utils/enums';

export const getStateIDFromStateCode = (stateCode: string): number | string => {
  const state = USStates().find((state) => state.label === stateCode);
  if (!state) {
    return '';
  } else {
    return Number(state.id);
  }
};

export const milesToMeters = (miles: number): number => {
  return miles * 1609.34; // 1 mile = 1609.34 meters
};

export const principalInitials = (principal: Principal) => {
  if (!!principal?.first_name && !!principal?.last_name) {
    return [principal?.first_name?.[0], principal?.last_name?.[0]];
  }
  return ['', ''];
};

export const formatTestId = (stringToFormat: string): string => {
  const stringWithoutParentheses = stringToFormat.replace(/\([^)]*\)/g, '');

  const trimmedString = stringWithoutParentheses.trim();

  return trimmedString.toLowerCase().replace(/[\s_]+/g, '-');
};

export const handleOpenConnectMatchQuiz = (
  userId: number,
  jobboardState: string,
  geocodedLocation: string
) => {
  // Regex to extract longitude and latitude from geocoded_location string, e.g. "SRID=4326;POINT (-73.9418603 40.7047738)"
  const GEOPOINT_REGEX = /POINT \((-?\d+\.\d+) (-?\d+\.\d+)\)/;
  const params: string[] = [];
  let url = `https://${connectRedirectUrls.MATCH_QUIZ}?visitorId=${userId}`;

  if (jobboardState) {
    params.push(`state=${CONNECT_JOBBOARD_STATES[jobboardState]?.stateCode}`);
  }

  if (geocodedLocation) {
    // Validate and extract coordinates; throw an error if the format changes (e.g. due to backend changes)
    const geocodedLongitudeAndLatitude = geocodedLocation.match(GEOPOINT_REGEX);
    if (geocodedLongitudeAndLatitude) {
      params.push(
        `longitude=${geocodedLongitudeAndLatitude[1]}`,
        `latitude=${geocodedLongitudeAndLatitude[2]}`
      );
    } else {
      // Throw an error if the backend format changes or is invalid
      throw new Error(
        `Could not extract longitude/latitude from geocodedLocation: ${geocodedLocation}`
      );
    }
  }

  if (params.length > 0) {
    url += `&${params.join('&')}`;
  }

  window.open(url, '_blank', 'noopener,noreferrer');
};
